(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5003],{

/***/ 13880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ 94640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PictureWithLinkComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82305);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var PictureWithLinkComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PictureWithLinkComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PictureWithLinkComponent);
    function PictureWithLinkComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PictureWithLinkComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onClick", function(e) {
            var _props = _this.props, href = _props.href, src = _props.src;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.PICTURE_WITH_LINK_CLICKED, {
                kind: href,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: src
            });
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(PictureWithLinkComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, href = _this_props.href, target = _this_props.target, otherProps = _object_without_properties(_this_props, [
                    "href",
                    "target"
                ]);
                if (href) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: href,
                        target: target,
                        onClick: this.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps))
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps));
            }
        }
    ]);
    return PictureWithLinkComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

PictureWithLinkComponent.defaultProps = {
    target: "_self"
};


/***/ }),

/***/ 69737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ badges_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-const.js
var badges_const = __webpack_require__(25627);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./components/core/images-gallery/images-gallery-row/images-gallery-row-component.js + 3 modules
var images_gallery_row_component = __webpack_require__(99112);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/default-props.js
var default_props = __webpack_require__(26455);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-desktop/badges-grid-desktop-component.scss.js



var StyledBadgesGridDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1duxf0w0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding-right:", function(param) {
    var horizontalPadding = param.horizontalPadding;
    return horizontalPadding || default_props/* default.horizontalPadding */.Z.horizontalPadding;
}, ";padding-left:", function(param) {
    var horizontalPadding = param.horizontalPadding;
    return horizontalPadding || default_props/* default.horizontalPadding */.Z.horizontalPadding;
}, ";.images-gallery-row{flex-wrap:nowrap;gap:12px;.image-gallery{.picture-component{img{min-width:72px;width:100%;height:100%;object-fit:contain;max-width:120px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-desktop/badges-grid-desktop-component.js



var BadgesGridDesktopComponent = function(param) {
    var badges = param.badges, horizontalPadding = param.horizontalPadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgesGridDesktopComponent, {
        horizontalPadding: horizontalPadding,
        className: "badges-grid-desktop-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_gallery_row_component/* default */.Z, {
            assets: badges
        })
    });
};
/* harmony default export */ var badges_grid_desktop_component = (BadgesGridDesktopComponent);

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-mobile/badges-grid-mobile-component.scss.js

var StyledBadgesGridMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehaikjk0"
})(".badge-wrapper{padding:8px;}.slick-list{padding:0 20% 0;.slick-track{.slick-slide{.picture-component{img{width:100%;height:100%;object-fit:contain;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/components/badges-grid-mobile/badges-grid-mobile-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var BadgesGridMobileComponent = function(param) {
    var badges = param.badges;
    var itemRenderer = function(param) {
        var url = param.url, name = param.name;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "badge-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                src: url,
                alt: name
            })
        });
    };
    var carouselProps = {
        items: badges,
        itemRenderer: itemRenderer,
        defaultIndex: Math.floor(badges.length / 2),
        infinite: false,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgesGridMobileComponent, {
        className: "badges-grid-mobile-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, _object_spread({}, carouselProps))
    });
};
/* harmony default export */ var badges_grid_mobile_component = (BadgesGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-grid-component.js







var BadgesGridComponent = function(param) {
    var product = param.product, country = param.country, horizontalPadding = param.horizontalPadding;
    var badges = (0,react.useMemo)(function() {
        var _BADGES_PER_PRODUCT_BY_COUNTRY_product, _BADGES_PER_PRODUCT_BY_COUNTRY_product1;
        return ((_BADGES_PER_PRODUCT_BY_COUNTRY_product = badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[product]) === null || _BADGES_PER_PRODUCT_BY_COUNTRY_product === void 0 ? void 0 : _BADGES_PER_PRODUCT_BY_COUNTRY_product[country]) || ((_BADGES_PER_PRODUCT_BY_COUNTRY_product1 = badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[product]) === null || _BADGES_PER_PRODUCT_BY_COUNTRY_product1 === void 0 ? void 0 : _BADGES_PER_PRODUCT_BY_COUNTRY_product1[badges_const/* BADGES_COUNTRIES.GENERAL */.W.GENERAL]) || badges_const/* BADGES_PER_PRODUCT_BY_COUNTRY */.M[products/* WORK_MANAGEMENT_PRODUCT_ID */.py][badges_const/* BADGES_COUNTRIES.GENERAL */.W.GENERAL];
    }, [
        product
    ]);
    var BadgesResponsiveComponent = (0,react.useMemo)(function() {
        return (0,responsive_hoc_component/* default */.Z)(badges_grid_desktop_component, badges_grid_mobile_component);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgesResponsiveComponent, {
        badges: badges,
        horizontalPadding: horizontalPadding
    });
};
/* harmony default export */ var badges_grid_component = (BadgesGridComponent);


/***/ }),

/***/ 42057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES = (__webpack_require__(72632).COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES);
var CLOUDFRONT_MOBILE_HEADER = "cloudfront-is-mobile-viewer";
var CLOUDFRONT_TABLET_HEADER = "cloudfront-is-tablet-viewer";
var CLOUDFRONT_DESKTOP_HEADER = "cloudfront-is-desktop-viewer";
var CLOUDFRONT_COUNTRY_HEADER = "cloudfront-viewer-country";
var isMobileOrTablet = function(req) {
    return isMobile(req) || isTablet(req);
};
var isMobile = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_MOBILE_HEADER] && headers[CLOUDFRONT_MOBILE_HEADER] === "true";
};
var isTablet = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_TABLET_HEADER] && headers[CLOUDFRONT_TABLET_HEADER] === "true";
};
var isDesktop = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_DESKTOP_HEADER] && headers[CLOUDFRONT_DESKTOP_HEADER] === "true";
};
var isCookiesPolicyRequiredCountryFromServer = function(res) {
    var cloudFrontCountry = res.getHeader(CLOUDFRONT_COUNTRY_HEADER);
    return doesCountryRequireStrictCookiePolicy(cloudFrontCountry);
};
var doesCountryRequireStrictCookiePolicy = function(cloudFrontCountry) {
    return cloudFrontCountry && COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES.includes(cloudFrontCountry);
};
module.exports = {
    isMobileOrTablet: isMobileOrTablet,
    isDesktop: isDesktop,
    isMobile: isMobile,
    isTablet: isTablet,
    isCookiesPolicyRequiredCountryFromServer: isCookiesPolicyRequiredCountryFromServer,
    doesCountryRequireStrictCookiePolicy: doesCountryRequireStrictCookiePolicy
};


/***/ }),

/***/ 77784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref = __webpack_require__(85010), isCountryInContinent = ref.isCountryInContinent, OCEANIA = ref.OCEANIA;
var ref1 = __webpack_require__(13019), USE_OLD_STORAGE_SETTINGS = ref1.USE_OLD_STORAGE_SETTINGS, WEBSITE_AB_TEST_DEBUG_COOKIE_NAME = ref1.WEBSITE_AB_TEST_DEBUG_COOKIE_NAME;
var getAbTestVariantNew = (__webpack_require__(41871).getAbTestVariantNew);
var doesCountryRequireStrictCookiePolicy = (__webpack_require__(42057).doesCountryRequireStrictCookiePolicy);
var isRunningInClient = (__webpack_require__(44566).isRunningInClient);
var ref2 = __webpack_require__(60734), SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST = ref2.SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, EXIT_POP_UP_SURVEY_AB_TEST = ref2.EXIT_POP_UP_SURVEY_AB_TEST, REVIVE_EXIT_POPUP_AB_TEST = ref2.REVIVE_EXIT_POPUP_AB_TEST, PERFORMANCE_STATIC_PAGE_AB_TEST = ref2.PERFORMANCE_STATIC_PAGE_AB_TEST, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES = ref2.BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST = ref2.DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST = ref2.PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST, MOBILE_STICKY_SIGNUP_AB_TEST = ref2.MOBILE_STICKY_SIGNUP_AB_TEST, WELCOME_BACK_PAGE_TEST = ref2.WELCOME_BACK_PAGE_TEST, KEEP_REGION_TEST = ref2.KEEP_REGION_TEST, CONTACT_SALES_TYPEFORM_EMEA = ref2.CONTACT_SALES_TYPEFORM_EMEA, CONTACT_SALES_TYPEFORM_ANZ = ref2.CONTACT_SALES_TYPEFORM_ANZ, HEADER_NEW_PRODUCTS_OFFERING_TEST = ref2.HEADER_NEW_PRODUCTS_OFFERING_TEST, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST = ref2.UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST, MOBILE_SOFT_SIGNUP_TEST = ref2.MOBILE_SOFT_SIGNUP_TEST, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST = ref2.TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST, STUDIO_IN_HEADER_TEST = ref2.STUDIO_IN_HEADER_TEST, ENHANCED_PRODUCTS_IN_HEADER_TEST = ref2.ENHANCED_PRODUCTS_IN_HEADER_TEST, WM_HIGH_INTENT_EXPERIENCE = ref2.WM_HIGH_INTENT_EXPERIENCE, CONTACT_SALES_FOOTER_TEST = ref2.CONTACT_SALES_FOOTER_TEST, DACH_GET_STARTED_BUTTON_TEXT_TEST = ref2.DACH_GET_STARTED_BUTTON_TEXT_TEST, BOOK_A_MEETING_EMAIL_TEST = ref2.BOOK_A_MEETING_EMAIL_TEST;
var shouldGetSkipSignUpStepInPricingAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, sendBigBrainEvent) === "new_with_skip";
};
var shouldSeeExitPopupSurveyAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 ? arguments[1] : void 0;
    return getAbTestVariantNew(abTests, EXIT_POP_UP_SURVEY_AB_TEST, sendBigBrainEvent) === "new_with_survey";
};
var shouldSeeReviveExitPopupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REVIVE_EXIT_POPUP_AB_TEST.test_name, sendBigBrainEvent) === REVIVE_EXIT_POPUP_AB_TEST.new_variation_name;
};
var shouldSeeStaticPagePerformanceAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (doesCountryRequireStrictCookiePolicy(cloudfrontViewerCountry)) return false;
    return getAbTestVariantNew(abTests, PERFORMANCE_STATIC_PAGE_AB_TEST.test_name, sendBigBrainEvent) === PERFORMANCE_STATIC_PAGE_AB_TEST.new_variation_name;
};
var shouldShowBiggerStorageInPricingFeatures = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
        return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
    }
    return getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) === BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name;
};
var shouldSeeDesktopWithEnterpriseMenuAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.test_name, sendBigBrainEvent) === DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.new_variation_name;
};
var shouldGetEnterpriseContactUsPageAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.test_name, sendBigBrainEvent) === PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.new_variation_name;
};
var shouldGetMobileStickySignupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, MOBILE_STICKY_SIGNUP_AB_TEST.test_name, sendBigBrainEvent) === MOBILE_STICKY_SIGNUP_AB_TEST.new_variation_name;
};
var shouldGetWelcomeBackPageTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], persistantCookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraBigBrainParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (persistantCookies[WEBSITE_AB_TEST_DEBUG_COOKIE_NAME] === WELCOME_BACK_PAGE_TEST.test_name) return true;
    return getAbTestVariantNew(abTests, WELCOME_BACK_PAGE_TEST.test_name, sendBigBrainEvent, false, extraBigBrainParams) === WELCOME_BACK_PAGE_TEST.new_variation_name;
};
var shouldGetKeepRegionTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    try {
        var _localStorage;
        if (isRunningInClient() && ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("is_in_keep_region_test")) === "true") {
            return true;
        }
        if (isCountryInContinent(cloudfrontViewerCountry, OCEANIA)) {
            // only people from Oceanic countries should enter the test
            return getAbTestVariantNew(abTests, KEEP_REGION_TEST.test_name, sendBigBrainEvent) === KEEP_REGION_TEST.new_variation_name;
        }
    } catch (error) {
    // nothing to do - just done to protect from crashes
    }
    return false;
};
var shouldGetContactSalesTypeformEmeaTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_EMEA.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_EMEA.new_variation_name;
};
var shouldGetContactSalesTypeformAnzTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_ANZ.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_ANZ.new_variation_name;
};
var shouldHaveHeaderWithNewProductsOfferingTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, HEADER_NEW_PRODUCTS_OFFERING_TEST.test_name, sendBigBrainEvent) === HEADER_NEW_PRODUCTS_OFFERING_TEST.new_variation_name;
};
var shouldGetUnlimitedTimeCTATextTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.test_name, sendBigBrainEvent) === UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.new_variation_name;
};
var shouldGetMobileSoftSignupTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, MOBILE_SOFT_SIGNUP_TEST.test_name, sendBigBrainEvent) === MOBILE_SOFT_SIGNUP_TEST.new_variation_name;
};
var shouldUseNewTypeformVariant = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.test_name, sendBigBrainEvent) === TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.new_variation_name;
};
var shouldHaveStudioProductInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, STUDIO_IN_HEADER_TEST.test_name, sendBigBrainEvent) === STUDIO_IN_HEADER_TEST.new_variation_name;
};
var shouldHaveEnhancedProductsInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, ENHANCED_PRODUCTS_IN_HEADER_TEST.test_name, sendBigBrainEvent) === ENHANCED_PRODUCTS_IN_HEADER_TEST.new_variation_name;
};
var shouldGetWMHighIntentExperience = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, WM_HIGH_INTENT_EXPERIENCE.test_name, sendBigBrainEvent) === WM_HIGH_INTENT_EXPERIENCE.new_variation_name;
};
var shouldGetContactSalesInTheFooter = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_FOOTER_TEST.test_name, sendBigBrainEvent) === CONTACT_SALES_FOOTER_TEST.new_variation_name;
};
var shouldUseNewDachGetStartedButtonTextTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, DACH_GET_STARTED_BUTTON_TEXT_TEST.test_name, sendBigBrainEvent) === DACH_GET_STARTED_BUTTON_TEXT_TEST.new_variation_name;
};
var shouldSendBookAMeetingEmail = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, BOOK_A_MEETING_EMAIL_TEST.test_name, sendBigBrainEvent) === BOOK_A_MEETING_EMAIL_TEST.new_variation_name;
};
module.exports = {
    shouldGetSkipSignUpStepInPricingAbTest: shouldGetSkipSignUpStepInPricingAbTest,
    shouldSeeExitPopupSurveyAbTest: shouldSeeExitPopupSurveyAbTest,
    shouldSeeReviveExitPopupAbTest: shouldSeeReviveExitPopupAbTest,
    shouldSeeStaticPagePerformanceAbTest: shouldSeeStaticPagePerformanceAbTest,
    shouldShowBiggerStorageInPricingFeatures: shouldShowBiggerStorageInPricingFeatures,
    shouldSeeDesktopWithEnterpriseMenuAbTest: shouldSeeDesktopWithEnterpriseMenuAbTest,
    shouldGetEnterpriseContactUsPageAbTest: shouldGetEnterpriseContactUsPageAbTest,
    shouldGetMobileStickySignupAbTest: shouldGetMobileStickySignupAbTest,
    shouldGetWelcomeBackPageTest: shouldGetWelcomeBackPageTest,
    shouldGetKeepRegionTest: shouldGetKeepRegionTest,
    shouldGetContactSalesTypeformEmeaTest: shouldGetContactSalesTypeformEmeaTest,
    shouldGetContactSalesTypeformAnzTest: shouldGetContactSalesTypeformAnzTest,
    shouldHaveHeaderWithNewProductsOfferingTest: shouldHaveHeaderWithNewProductsOfferingTest,
    shouldGetUnlimitedTimeCTATextTest: shouldGetUnlimitedTimeCTATextTest,
    shouldGetMobileSoftSignupTest: shouldGetMobileSoftSignupTest,
    shouldUseNewTypeformVariant: shouldUseNewTypeformVariant,
    shouldHaveStudioProductInHeaderTest: shouldHaveStudioProductInHeaderTest,
    shouldHaveEnhancedProductsInHeaderTest: shouldHaveEnhancedProductsInHeaderTest,
    shouldGetWMHighIntentExperience: shouldGetWMHighIntentExperience,
    shouldGetContactSalesInTheFooter: shouldGetContactSalesInTheFooter,
    shouldUseNewDachGetStartedButtonTextTest: shouldUseNewDachGetStartedButtonTextTest,
    shouldSendBookAMeetingEmail: shouldSendBookAMeetingEmail
};


/***/ })

}]);